document.querySelectorAll(".collection .singal-pi").forEach((item) => {
  const handleTouch = () => {
    item.classList.add("touched");
    setTimeout(() => {
      item.classList.remove("touched");
    }, 5000);
  };

  item.addEventListener("click", handleTouch);
  item.addEventListener("touchstart", handleTouch);
});

function updateFilterCounts() {
  document.querySelectorAll(".filter__group").forEach((group) => {
    const checkedInputs = group.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    const countEl = group.querySelector(".count");
    if (countEl) {
      if (checkedInputs.length > 0) {
        countEl.textContent = `(${checkedInputs.length})`;
        countEl.style.display = "inline";
      } else {
        countEl.textContent = "";
        countEl.style.display = "none";
      }
    }
  });
}
updateFilterCounts();
document.addEventListener("change", function (e) {
  const group = e.target.closest(".filter__group");
  if (group && e.target.type === "checkbox") {
    const checkedInputs = group.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    const countEl = group.querySelector(".count");
    if (countEl) {
      if (checkedInputs.length > 0) {
        countEl.textContent = `(${checkedInputs.length})`;
        countEl.style.display = "inline";
      } else {
        countEl.textContent = "";
        countEl.style.display = "none";
      }
    }
  }
});

const filterDrawer = document.querySelector(".filter__drawer");
if (filterDrawer) {
  // Create a MutationObserver instance
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        setTimeout(() => updateFilterCounts(), 100);
        break;
      }
    }
  });
  observer.observe(filterDrawer, {
    childList: true, // detects added/removed child nodes
    subtree: true, // includes all descendants
    characterData: true, // detects text changes
  });
}

function updateActiveFilter() {
  document.querySelectorAll(".filter__drawer").forEach((drawer) => {
    const filterMain = drawer.querySelector(".filter__main");
    if (!filterMain) return;
    const checkedCheckboxes = filterMain.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    if (checkedCheckboxes.length > 0) {
      drawer.classList.add("active-filter");
    } else {
      drawer.classList.remove("active-filter");
    }
  });
}
document.addEventListener("DOMContentLoaded", updateActiveFilter);
document.addEventListener("change", function (e) {
  if (e.target.matches('.filter__main input[type="checkbox"]')) {
    updateActiveFilter();
  }
});

document.addEventListener("click", function (e) {
  const showAllBtn = e.target.closest(".filter-show-all");
  if (showAllBtn) {
    document.body.classList.remove("filter-is-open");
  }
});

function initSwiperCards() {
  if (window.innerWidth <= 991) {
    document.querySelectorAll(".grid-mob-slider.swiper:not(.swiper-initialized)").forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          type: "progressbar",
        },
      });
    });
  }
}

initSwiperCards();
window.addEventListener("resize", initSwiperCards);

// Expose globally for restoreState
window.reinitGridSwiper = initSwiperCards;

let lastWindowWidth = window.innerWidth;

function applyDefaultGrid() {
  let savedGrid = localStorage.getItem("selectedGrid");

  if (!savedGrid) {
    if (window.innerWidth < 992) {
      savedGrid = "grid-2";
    } else {
      savedGrid = "grid-4";
    }
    localStorage.setItem("selectedGrid", savedGrid);
  }

  // Remove previous grid classes
  document.body.classList.remove("grid-1", "grid-2", "grid-3", "grid-4");
  // Add the saved grid class
  document.body.classList.add(savedGrid);
  // Add 'show-grid' immediately
  document.body.classList.add("show-grid");

  // Update button active state
  document.querySelectorAll(".coll-grid-btn").forEach((bar) => {
    bar
      .querySelectorAll(".grid-btn")
      .forEach((btn) => btn.classList.remove("active"));
    const activeBtn = bar.querySelector(`.grid-btn[data-id="${savedGrid}"]`);
    if (activeBtn) activeBtn.classList.add("active");
  });
}

document.addEventListener("DOMContentLoaded", applyDefaultGrid);

window.addEventListener("resize", () => {
  const currentWidth = window.innerWidth;
  if (
    (lastWindowWidth < 992 && currentWidth >= 992) ||
    (lastWindowWidth >= 992 && currentWidth < 992)
  ) {
    localStorage.removeItem("selectedGrid");
    applyDefaultGrid();
  }
  lastWindowWidth = currentWidth;
});

document.querySelectorAll(".coll-grid-btn").forEach((bar) => {
  bar.querySelectorAll(".grid-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const gridClass = this.getAttribute("data-id");
      document.body.classList.remove("grid-1", "grid-2", "grid-3", "grid-4");
      document.body.classList.add(gridClass);
      // Add 'show-grid' here too
      document.body.classList.add("show-grid");
      localStorage.setItem("selectedGrid", gridClass);
      bar
        .querySelectorAll(".grid-btn")
        .forEach((sib) => sib.classList.remove("active"));
      this.classList.add("active");
    });
  });
});

function initializeEventListeners() {
  // Initialize swiper for product cards (for newly loaded products)
  initSwiperCards();

  document.querySelectorAll(".collection .singal-pi").forEach((item) => {
    const handleTouch = () => {
      item.classList.add("touched");
      setTimeout(() => {
        item.classList.remove("touched");
      }, 5000);
    };

    item.addEventListener("click", handleTouch);
    item.addEventListener("touchstart", handleTouch);
  });
  
  // Shop icon click handlers
  document
    .querySelectorAll(".shop-icon:not([data-event-attached])")
    .forEach((icon) => {
      icon.setAttribute("data-event-attached", "true");
      icon.addEventListener("click", () => {
        const parent = icon.closest(".singal-pi");

        if (parent) {
          const siblings = parent.parentElement.children;

          Array.from(siblings).forEach((sibling) => {
            if (sibling !== parent) {
              sibling.classList.remove("active");
            }
          });

          parent.classList.toggle("active");
        }
      });
    });

  // Close button handlers
  document
    .querySelectorAll(".inner-pro-var .close-btn:not([data-event-attached])")
    .forEach((svg) => {
      svg.setAttribute("data-event-attached", "true");
      svg.addEventListener("click", () => {
        document.body.classList.remove("open-qv-popup");
        const parent = svg.closest(".singal-pi");
        parent.classList.remove("active");
      });
    });

  // Main var handlers
  document
    .querySelectorAll(".main-var .var:not([data-event-attached])")
    .forEach(function (element) {
      element.setAttribute("data-event-attached", "true");
      element.addEventListener("click", function () {
        document.body.classList.add("active-loader");
        setTimeout(function () {
          document.body.classList.remove("active-loader");
        }, 1900);
      });
    });

  // Quick add cart handlers
  document
    .querySelectorAll(".qv-btn .quick-add-cart:not([data-event-attached])")
    .forEach(function (element) {
      element.setAttribute("data-event-attached", "true");
      element.addEventListener("click", function () {
        document.body.classList.add("active-loader");
        setTimeout(function () {
          document.body.classList.remove("active-loader");
        }, 1900);
      });
    });

  document
    .querySelectorAll(".singal-pi .qv-btn.more-var:not([data-event-attached])")
    .forEach(function (button) {
      button.setAttribute("data-event-attached", "true");
      button.addEventListener("click", function () {
        var parent = this.closest(".singal-pi");
        // disableScroll();
        parent.classList.add("active");
        var siblings = parent.parentElement.children;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== parent) {
            siblings[i].classList.remove("active");
          }
        }
      });
    });

  document
    .querySelectorAll(".qv-btn .plus-btn:not([data-event-attached])")
    .forEach(function (element) {
      element.setAttribute("data-event-attached", "true");
      element.addEventListener("click", function () {
        document.body.classList.add("open-qv-popup");
      });
    });

  if (window.innerWidth < 768) {
    document.addEventListener("mouseup", function (e) {
      var clickplaces = document.querySelectorAll(
        ".mobile-pro-var .inner-pro-var",
      );
      var shouldClosePopup = true;

      clickplaces.forEach(function (clickplace) {
        if (clickplace.contains(e.target)) {
          shouldClosePopup = false;
        }
      });

      if (shouldClosePopup) {
        document.body.classList.remove("open-qv-popup");
        // enableScroll();
        var parentElement = e.target.closest(".singal-pi");
        if (parentElement) {
          parentElement.classList.remove("active");
        }
      }
    });
  }

  document
    .querySelectorAll(".mob-main-var .mob-var:not([data-event-attached])")
    .forEach(function (element) {
      element.setAttribute("data-event-attached", "true");
      element.addEventListener("click", function () {
        element.parentNode
          .querySelectorAll(".mob-var")
          .forEach(function (sibling) {
            sibling.classList.remove("active");
          });
        element.classList.add("active");
      });
    });

  document
    .querySelectorAll(".popup-add-cart .mob-main-var .mob-var")
    .forEach(function (element) {
      element.setAttribute("data-event-attached", "true");
      element.addEventListener("click", function () {
        var id = this.getAttribute("data-id");
        var button = this.closest(".inner-pro-var").querySelector(
          ".main-qv-add-btn .btn",
        );
        if (button) {
          button.setAttribute("data-id", id);
        }
      });
    });

  const buttons = document.querySelectorAll(
    ".main-qv-add-btn .btn:not([data-event-attached])",
  );
  buttons.forEach(function (button) {
    button.setAttribute("data-event-attached", "true");
    button.addEventListener("click", function () {
      document.body.classList.remove("open-qv-popup");
      this.parentElement.classList.add("active-loader");
      setTimeout(() => {
        this.closest(".singal-pi").classList.remove("active");
        this.parentElement.classList.remove("active-loader");
      }, 2000);
    });
  });
}

var combinedCallback = function () {
  if (typeof initializeEventListeners == "function") {
    initializeEventListeners();
  }
  if (typeof initializeAddToCartButtons == "function") {
    initializeAddToCartButtons();
  }
};

document.addEventListener("DOMContentLoaded", function () {
  initializeEventListeners();

  var infinitescroll = {
    scolljs: function () {
      var endlessScroll = new Ajaxinate({
        container: "#AjaxinateContainer",
        pagination: "#AjaxinatePagination",
        loadingText: "Loading more products...",
        callback: combinedCallback,
        // offset: 200
      });
    },
  };

  infinitescroll.scolljs();
});

window.addEventListener("load", initializeEventListeners);

function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#AjaxinateContainer").innerHTML;
  sessionStorage.setItem("loadedProducts", loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem("scrollPosition", scrollPosition);
  sessionStorage.setItem("collectionURL", window.location.href);

  var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
  if (ajaxinatePagination) {
    sessionStorage.setItem("ajaxinateHref", ajaxinatePagination.href);
    sessionStorage.setItem("ajaxinatePage", ajaxinatePagination.dataset.page);
  }
}

function restoreState() {
  if (window.location.pathname.includes("/collections")) {
    // Temporarily disable smooth-scroll class
    document.documentElement.classList.remove("scroll-smooth");

    var scrollPosition = sessionStorage.getItem("scrollPosition");
    var loadedProducts = sessionStorage.getItem("loadedProducts");
    var collectionURL = sessionStorage.getItem("collectionURL");
    var ajaxinateHref = sessionStorage.getItem("ajaxinateHref");
    var ajaxinatePage = sessionStorage.getItem("ajaxinatePage");
    console.log(ajaxinateHref, ajaxinatePage);

    if (scrollPosition && collectionURL === window.location.href) {
      setTimeout(function () {
        window.scrollTo(0, scrollPosition);
        sessionStorage.removeItem("scrollPosition");
        // Re-enable smooth-scroll class
        document.documentElement.classList.add("scroll-smooth");
      }, 0); // Delay to ensure DOM is fully rendered
    } else {
      // Re-enable smooth-scroll class if no scroll position to restore
      document.documentElement.classList.add("scroll-smooth");
    }
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#AjaxinateContainer").innerHTML = loadedProducts;
      sessionStorage.removeItem("loadedProducts");
      // Remove all data-event-attached attributes so listeners can be re-attached
      document.querySelectorAll("#AjaxinateContainer [data-event-attached]").forEach(el => {
        el.removeAttribute("data-event-attached");
      });
      // Remove swiper-initialized class so swipers can be re-initialized
      document.querySelectorAll("#AjaxinateContainer .swiper-initialized").forEach(el => {
        el.classList.remove("swiper-initialized");
      });
      // Remove touched class from any product cards
      document.querySelectorAll("#AjaxinateContainer .touched").forEach(el => {
        el.classList.remove("touched");
      });
      // Re-attach event listeners to restored products
      initializeEventListeners();
      // Reinitialize Swiper if it exists (for scarves collection)
      if (typeof window.reinitScarfSwiper === "function") {
        window.reinitScarfSwiper();
      }
      // Reinitialize grid mobile swiper
      if (typeof window.reinitGridSwiper === "function") {
        window.reinitGridSwiper();
      }
    }
    if (
      ajaxinateHref &&
      ajaxinatePage &&
      collectionURL === window.location.href
    ) {
      var ajaxinatePagination = document.querySelector(
        "#AjaxinatePagination a",
      );
      if (ajaxinatePagination) {
        setTimeout(function () {
          ajaxinatePagination.href = ajaxinateHref;
          ajaxinatePagination.dataset.page = ajaxinatePage;
        }, 1000); // Delay of 1 second
      }
      sessionStorage.removeItem("ajaxinateHref");
      sessionStorage.removeItem("ajaxinatePage");
    }
  }
}

document.addEventListener("DOMContentLoaded", restoreState);

document.addEventListener("click", function (event) {
  if (event.target.closest(".product-card a")) {
    saveLoadedProducts();
  }
});

window.addEventListener("beforeunload", function () {
  sessionStorage.setItem("scrollPosition", window.scrollY);
});

document.querySelectorAll(".header-nav a").forEach((anchor) => {
  anchor.addEventListener("click", function () {
    sessionStorage.clear();
  });
});

window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    restoreState();
  }
});
